import { Component, signal, output, input, inject, OnInit, LOCALE_ID, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';

import {
  Attribute,
  CategoryLookup,
  SubProductTableItem,
} from '../../../../../pages/admin-dashboard/products/add-sub-product/sub-products.model';
import { SuccessfulNotification } from '../../../../../utils/successful-notification/successful-notification';
import { SubProductForm } from '../../../add-product-component/steps/sub-products-step/sub-product-form/sub-product-form';
import { SubProductsTable } from '../../../add-product-component/steps/sub-products-step/sub-products-table/sub-products-table';
import { ProductService } from '../../../../../services/product/product.service';

@Component({
  selector: 'app-add-sub-product-form',
  standalone: true,
  imports: [CommonModule, SubProductForm, SubProductsTable, SuccessfulNotification],
  templateUrl: './add-sub-product-form.html',
  styleUrl: './add-sub-product-form.scss',
})
export class AddSubProductForm implements OnInit {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private locale = inject(LOCALE_ID);
  private productService = inject(ProductService);

  productId = input.required<number>();
  attributes = input<Attribute[]>([]);
  categories = input<CategoryLookup[]>([]);

  parentTitleEn = signal<string>('');
  parentTitleAr = signal<string>('');

  onBack = output<void>();
  onFinalSave = output<void>();

  subProductsList = signal<SubProductTableItem[]>([]);
  showSubProductSuccess = signal(false);

  productDisplayName = computed(() => {
    const isArabic = this.locale.startsWith('ar');
    const name = isArabic ? this.parentTitleAr() : this.parentTitleEn();
    return name || (isArabic ? 'جاري تحميل اسم المنتج...' : 'Loading product name...');
  });

  ngOnInit(): void {
    this.loadProductDetails();
  }

  loadProductDetails() {
    const id = this.productId();
    this.productService.getAdminProductById(id).subscribe({
      next: (data) => {
        this.parentTitleAr.set(data.titleAr || '');
        this.parentTitleEn.set(data.titleEn);
      },
      error: () => {
        console.error('Could not fetch product details');
      },
    });
  }

  onSubProductAdded(item: SubProductTableItem): void {
    this.subProductsList.update((list) => [...list, item]);
    this.showSubProductSuccess.set(true);
    setTimeout(() => {
      this.showSubProductSuccess.set(false);
    }, 2000);
  }

  handleFinalSave(): void {
    if (this.subProductsList().length > 0) {
      this.router.navigate(['/admin/products/view-product', this.productId()]);
    }
  }

  // removeFromTable(index: number): void {
  //   this.subProductsList.update(list => list.filter((_, i) => i !== index));
  // }
}
